import { Component, ViewChild } from '@angular/core';
import { MatTab } from '@angular/material/tabs';
import { Subject, forkJoin } from 'rxjs';
import { BackendApiService } from 'src/app/core/services/backend-api';
import { MyDocumentsData, MyDocuments } from 'src/app/shared/models/database-models/MyDocuments.model';
import { KeycloakService } from 'keycloak-angular';

@Component({
  selector: 'app-my-documents',
  templateUrl: './my-documents.component.html',
  styleUrls: ['./my-documents.component.scss']
})
export class MyDocumentsComponent {
  destroy$: Subject<boolean> = new Subject<boolean>();
  selectedIndex: number = 0;
  isDataLoaded: boolean = false;
  @ViewChild("formTabs") matTab!: MatTab;
  docTabs = [
    { label: 'All', badge: 0, data: [] as MyDocuments[] },
    { label: 'Draft', badge: 0, data: [] as MyDocuments[] },
    { label: 'Pending', badge: 0, data: [] as MyDocuments[] },
    { label: 'Completed', badge: 0, data: [] as MyDocuments[] },
  ];

  constructor(private backendService: BackendApiService,private keycloakService: KeycloakService,) { }

  async ngOnInit(): Promise<void> {
    this.loadAllData();
  }

  loadAllData() {
    // Determine visibility at frontend
    let userRoleFromKeyCloak = this.keycloakService.getUserRoles();
    // If user is IT Support, Contract Executives, Finance Admin, or Purchase Executives, show deleted docs
    const isDeletedVisibility = userRoleFromKeyCloak.some(role => ['IT Support', 'Contract Executives', 'Contracts Admin', 'Purchasing Admin', 'Finance Admin', 'Purchase Executives'].includes(role));
    // Pass as boolean to match backend signature
    const countRequests = this.docTabs.map(tab =>
      this.backendService.getMyDocuments('1', tab.label, '20', null, null, isDeletedVisibility)
    );

    forkJoin(countRequests).subscribe({
      next: (responses: MyDocumentsData[]) => {
        responses.forEach((data, index) => {
          this.docTabs[index].data = data.documents;
          this.docTabs[index].badge = data.totalCount;
        });
      },
      error: (err) => {
        console.error('Error fetching document data:', err);
        this.isDataLoaded = true;
      },
      complete: () => {
        console.log('All Tabs data loaded successfully.');
        this.isDataLoaded = true;
      }
    });
  }

  onSelectedIndexChange(event: number) {
    // set selectedIndex for the tabs
    this.selectedIndex = event;
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
